export default __webpack_public_path__ + "static/media/icon-close.bde602ec.svg";